import { render } from "./RightSidePanel.vue?vue&type=template&id=4a360b67&scoped=true"
import script from "./RightSidePanel.vue?vue&type=script&lang=js"
export * from "./RightSidePanel.vue?vue&type=script&lang=js"

import "./RightSidePanel.vue?vue&type=style&index=0&id=4a360b67&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a360b67"]])

export default __exports__